export default __webpack_public_path__ + "static/media/wishlist.579daa11.svg";